import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {fadeInRightAnimation} from '../../../@fury/animations/fade-in-right.animation';
import {scaleInAnimation} from '../../../@fury/animations/scale-in.animation';
import {fadeInUpAnimation} from '../../../@fury/animations/fade-in-up.animation';
import {Subject} from 'rxjs';
import {FiltersService} from '../../services/base/filters.service';
import {takeUntil} from 'rxjs/operators';
import {Company} from '../../interfaces/info/company';
import {HeadCategory} from '../../interfaces/routering/head-category';
import {MainCategoriesSurroundings} from '../../interfaces/configuration/main-categories-surroundings';
import {MainCategory} from '../../interfaces/routering/main-category';
import {SubCategory} from '../../interfaces/routering/sub-category';
import {ReporterType} from '../../interfaces/configuration/reporter-type';
import {IntegratedOptions} from '../../interfaces/base/integrated-options';
import {WebformService} from '../../services/reports/webform.service';
import {Router} from '@angular/router';
import {ReportCreated} from '../../interfaces/report/report-created';
import {LayoutService} from '../../layout/layout.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'fury-normal-form-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ControlComponent implements OnInit, OnDestroy {

  public filters = {
    'mainCategoriesSurroundings': {
      preload: true,
      isLoading: false,
      data: <MainCategoriesSurroundings[]>[]
    },
    'headCategories': {
      preload: false,
      isLoading: false,
      data: <HeadCategory[]>[]
    },
    'mainCategories': {
      preload: false,
      isLoading: false,
      data: <MainCategory[]>[]
    },
    'subCategories': {
      preload: false,
      isLoading: false,
      data: <SubCategory[]>[]
    },
    'yesNo': {
      preload: true,
      isLoading: false,
      data: <IntegratedOptions[]>[]
    },
    'reporterTypes': {
      preload: true,
      isLoading: false,
      data: <ReporterType[]>[]
    },
    'personPrefix': {
      preload: true,
      isLoading: false,
      data: <IntegratedOptions[]>[]
    },
    'companies': {
      preload: false,
      isLoading: false,
      data: <Company[]>[]
    },
  };

  @ViewChild('attachmentsPlaceholder', {read: ViewContainerRef}) attachmentsPlaceholder: ViewContainerRef;

  public form: any = null;
  public formSubmitting: boolean = false;
  public formSubmitError: boolean = false;
  public formSubmitErrorSubmitted: boolean = false;

  public uploadProgress: number = 0;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private filtersService: FiltersService,
              private router: Router,
              private cd: ChangeDetectorRef,
              private layoutService: LayoutService,
              private titleService: Title,
              public webformService: WebformService,
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('Controle melding - Milieu Klachten Centrale');
    this.layoutService.isPublicNotificationVisible.emit(false);

    if (this.webformService.checkForm === false) {
      this.router.navigateByUrl('/').then((): void => {
      });
    } else {
      this.filtersService.filters = this.filters;
      if (this.webformService.formType === 'normal') {
        this.layoutService.isPublicNotificationVisible.emit(true);
        this.form = this.webformService.normalForm;
      } else {
        this.form = this.webformService.companyForm;
      }

      Object.keys(this.filters).map((filter: string): void => {
        if (this.filters[filter].preload) {
          this.filtersService[filter]().pipe(takeUntil(this.destroy$)).subscribe((data: any): void => {
            if (data) {
              this.filters[filter].data = data;
            }
          });
        }
      });

      if (typeof this.form.controls.surrounding_id !== 'undefined') {
        this.filtersService.headCategories(this.form.controls.surrounding_id.value).pipe(takeUntil(this.destroy$)).subscribe((response: HeadCategory[] | false): void => {
          this.filters.headCategories.isLoading = false;

          if (response) {
            this.filters.headCategories.data = response;
            this.cd.detectChanges();
          }
        });

        if (typeof this.form.controls.head_category_id !== 'undefined') {
          this.filtersService.mainCategories(this.form.controls.head_category_id.value, this.form.controls.surrounding_id.value).pipe(takeUntil(this.destroy$)).subscribe((response: MainCategory[] | false): void => {
            this.filters.mainCategories.isLoading = false;

            if (response) {
              this.filters.mainCategories.data = response;
              this.cd.detectChanges();
            }
          });
        }
      }

      if (typeof this.form.controls.head_category_id !== 'undefined' && typeof this.form.controls.main_category_id !== 'undefined') {
        if (this.form.controls.sub_category_id.value) {
          this.filtersService.subCategories(this.form.controls.head_category_id.value, this.form.controls.main_category_id.value).pipe(takeUntil(this.destroy$)).subscribe((response: SubCategory[] | false): void => {
            this.filters.subCategories.isLoading = false;

            if (response) {
              this.filters.subCategories.data = response;
              this.cd.detectChanges();
            }
          });
        }
      }
    }
  }

  editForm(section: string): void {
    if (this.webformService.formType === 'normal') {
      this.router.navigateByUrl('/klacht-overlast#' + section).then(() => {
      });
    } else {
      this.router.navigateByUrl('/bedrijfsmelding#' + section).then(() => {
      });
    }
  }

  getTextValue(attribute: string, id: number): string {
    if (attribute === 'suspectTypes') {
      if (typeof this.filters.reporterTypes.data !== 'undefined') {
        const index: number = this.filters.reporterTypes.data.findIndex((d: any): boolean => d.name === id);

        if (index !== -1) {
          return this.filters.reporterTypes.data[index].display_name;
        }
      }
    } else if (attribute === 'reporterTypes') {
      if (typeof this.filters.reporterTypes.data !== 'undefined') {
        const index: number = this.filters.reporterTypes.data.findIndex((d: any): boolean => d.id === id);

        if (index !== -1) {
          return this.filters.reporterTypes.data[index].display_name;
        }
      }
    } else {
      if (typeof this.filters[attribute].data !== 'undefined') {
        const index: number = this.filters[attribute].data.findIndex((d: any): boolean => d.id === id);

        if (index !== -1) {
          return this.filters[attribute].data[index].name;
        }
      }
    }

    return null;
  }

  submit(): void {
    this.formSubmitting = true;
    this.formSubmitError = false;
    this.layoutService.scrollToTop.next();

    const action: string = this.webformService.formType === 'normal' ? 'saveNormalReport' : 'saveCompanyReport';

    this.webformService[action](this.form.value).subscribe((value: number | ReportCreated | boolean): void => {
      if (typeof value === 'number') {
        this.uploadProgress = value;
      } else if (value === false) {
        if (this.webformService.hasValidErrors) {
          this.router.navigate([(this.webformService.formType === 'normal' ? '/klacht-overlast' : '/bedrijfsmelding')]).then(() => {
          });
        } else {
          this.formSubmitting = false;
          this.formSubmitError = true;
        }
      } else {
        this.webformService.report = <ReportCreated>value;
        this.router.navigate(['/vastgelegd/' + (<ReportCreated>value).unique_number]).then((): void => {
        });
      }
    });
  }

  failedReport(): void {
    this.formSubmitting = true;
    this.formSubmitErrorSubmitted = false;
    this.webformService.forwardFailedReport(this.form.value).subscribe((value: boolean): void => {
      this.formSubmitting = false;
      if (value) {
        this.formSubmitError = false;
        this.formSubmitErrorSubmitted = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
